import { Helmet, history, useModel } from '@umijs/max';
import { PullRefresh, Search, List, Cell, Typography } from 'react-vant';
import { useRef, useState } from 'react';
import NoData from '@/components/NoData';
import { getWechatGuide } from '@/service/banner';
import styles from './index.less'

const WorkGuide = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [finished, setFinished] = useState<boolean>(false);
  const [workGuideList, setWorkGuideList] = useState<any>([]);
  const search = (val: any) => {
    setSearchValue(val);
    onRefresh()
  };
  const { defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
    }),
  );

  const pageNum  = useRef(1);
  
 
  const onLoadRefresh = async (isRefresh: boolean | undefined) => {
    setWorkGuideList([])

    const data = await getWechatGuide({ pageNum: pageNum.current, pageSize: 10, status: '1', title: searchValue, communityId: defaultRoom?.communityId})
    const listData: any =  [...workGuideList, ...data.rows]
    if (isRefresh || pageNum.current === 1) {
      setWorkGuideList(data.rows); 
    } else {
      setWorkGuideList(listData);
    }
 
    
    // console.log(listData, data)
    if (data.rows.length === data.total || data.rows.length < 10 || !data.rows.length || data.total === 0) { // 如果没有更多数据，则结束加载状态并设置finished为true
      setFinished(true);
    } else {
      pageNum.current = pageNum.current + 1
      setFinished(false); // 仍有数据可加载，保持为false
    }
  }

  const onRefresh = async () => {
    pageNum.current = 1
    setFinished(true)
    setWorkGuideList([])
    onLoadRefresh(true)
  }

  const viewDatail = (item: any) => {
    history.push(`/workGuideDetail?sequenceNbr=${item.sequenceNbr}`);
  }

  return (
    <div>
      <Helmet>
        <title>办事指南</title>
      </Helmet>
      <Search
        value={searchValue}
        onChange={setSearchValue}
        showAction
        actionText={<div onClick={(val) =>search(val)}>搜索</div>}
      />
      
        <PullRefresh onRefresh={onRefresh}>
          <List finished={finished} onLoad={onLoadRefresh} finishedText={!workGuideList ?.length ? '' : '没有更多了'}>
          {workGuideList.length ? <> {workGuideList.map((item: any) => (
              <div className={styles.container} key={item.sequenceNbr}>
                <div className={styles.containerItem} >
                  <div className={styles.title} onClick={() => viewDatail(item)}>{item.title}</div>
                  <div className={styles.time} onClick={() => viewDatail(item)}>
                    <div>发布时间：</div>
                    <div>{item.publishTime}</div>
                  </div>
                  <Cell><Typography.Text ellipsis={{
                    rows: 2,
                    collapseText: '收起',
                    expandText: '展开',
                  }} >{item.description}</Typography.Text></Cell>
                  
                </div>
                
            </div>
            ))}
           </>: (
          finished &&   <NoData />
          )}
          </List>
        </PullRefresh>
      
    </div>
  );
};

export default WorkGuide;
